import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { useAppSelector } from 'src/store/reducers';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

import SafeHTML from '@helsenorge/framework-utils/components/safe-html';

export const LoadSkjemaWarningMessageNotification = (): React.JSX.Element | null => {
  const loadSkjemaoppgaveWarningMessage = useAppSelector(state => state.refero.ui.loadSkjemaoppgaveWarningMessage);
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);

  const warningTitle = loadSkjemaoppgaveWarningMessage?.Title;
  const warningBody = loadSkjemaoppgaveWarningMessage?.Body;

  return loadSkjemaoppgaveWarningMessage ? (
    <section className="defaultspacing">
      <NotificationPanel
        testId="notification-panel-load-skjemaoppgave-warning-message"
        variant="warn"
        label={resources?.[warningTitle as keyof HNSkjemaFrontend] || warningTitle}
      >
        <SafeHTML html={resources?.[warningBody as keyof HNSkjemaFrontend] || warningBody} type="markdown" />
      </NotificationPanel>
    </section>
  ) : null;
};
export default LoadSkjemaWarningMessageNotification;
